import React from 'react';
import BarrelMark from './BarrelMark';

interface SbdWordmarkProps {
  variant?: 'dark' | 'light';
  /** Compact nav variant: 22px mark, 13px/9px text. Default is the large family lockup. */
  compact?: boolean;
  className?: string;
}

const COLORS = {
  dark: { primary: '#FAF6F0', accent: '#4FA8A4' },
  light: { primary: '#1A1208', accent: '#1F5C5A' },
};

const SbdWordmark: React.FC<SbdWordmarkProps> = ({ variant = 'dark', compact = false, className }) => {
  const c = COLORS[variant];

  if (compact) {
    // Nav header spec from components-nav.html: 22px mark, 13px "Small Batch", 9px "Digital · Menu"
    return (
      <div
        className={className}
        role="img"
        aria-label="Small Batch Digital"
        style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
      >
        <BarrelMark variant={variant} width={22} height={28} />
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1, gap: 3 }}>
          <span
            style={{
              fontFamily: "'Josefin Slab', serif",
              fontWeight: 600,
              fontSize: '13px',
              letterSpacing: '0.04em',
              textTransform: 'uppercase',
              color: c.primary,
            }}
          >
            Small Batch
          </span>
          <span
            style={{
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: 600,
              fontSize: '9px',
              letterSpacing: '2.5px',
              textTransform: 'uppercase',
              color: c.accent,
              marginTop: 3,
            }}
          >
            Digital · Menu
          </span>
        </div>
      </div>
    );
  }

  // Large family lockup for login card / splash contexts
  return (
    <div
      className={className}
      role="img"
      aria-label="Small Batch Digital"
      style={{ display: 'flex', alignItems: 'center', gap: '12px' }}
    >
      <BarrelMark variant={variant} width={36} height={46} />
      <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1, gap: 3 }}>
        <span
          style={{
            fontFamily: "'Josefin Slab', serif",
            fontWeight: 600,
            fontSize: '18px',
            letterSpacing: '0.04em',
            textTransform: 'uppercase',
            color: c.primary,
          }}
        >
          Small Batch
        </span>
        <span style={{ display: 'flex', alignItems: 'baseline', gap: '8px', whiteSpace: 'nowrap' }}>
          <span
            style={{
              fontFamily: "'Josefin Slab', serif",
              fontWeight: 600,
              fontSize: '13px',
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
              color: c.primary,
            }}
          >
            Digital
          </span>
          <span
            style={{
              fontFamily: "'DM Sans', sans-serif",
              fontWeight: 600,
              fontSize: '10px',
              letterSpacing: '2px',
              textTransform: 'uppercase',
              color: c.accent,
            }}
          >
            — Menu —
          </span>
        </span>
      </div>
    </div>
  );
};

export default SbdWordmark;
